/**
 * Local storage keys used throughout the application
 * Using constants prevents typos and makes refactoring easier
 */
export const STORAGE_KEYS = {
  // Authentication (matching backend format)
  TOKEN: 'token', // JWT token key (matches old system)
  AUTH_TOKEN: 'pubsub-auth-token', // Deprecated, kept for migration
  REFRESH_TOKEN: 'pushub-refresh-token',
  USER: 'currentUser', // User data key (matches old system)
  
  // User preferences
  THEME: 'pushub-theme',
  LANGUAGE: 'pushub-language',
  
  // App state
  SIDEBAR_COLLAPSED: 'pushub-sidebar-collapsed',
  LAST_VISITED_PAGE: 'pushub-last-page',
  
  // Cache
  CACHE_TIMESTAMP: 'pushub-cache-ts',
  CACHE_DATA: 'pushub-cache-data',
} as const;

/**
 * Session storage keys (cleared when browser closes)
 */
export const SESSION_KEYS = {
  TEMP_AUTH: 'pushub-temp-auth',
  FORM_DATA: 'pushub-form-data',
} as const;

/**
 * Cookie names
 */
export const COOKIE_KEYS = {
  REMEMBER_ME: 'pushub-remember',
  SESSION_ID: 'pushub-session',
} as const;


